import React, { Component } from 'react';
import './Header.css';

export default class Header extends Component {
  render() {
    return(
      <div>
        <div className='hero'> </div>
        <p className='title'>Phone Triage</p>
      </div>
    )
  }
}